import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, IconButton, Avatar, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import ProjectSelector from './ProjectSelector';
import InstallButton from './InstallButton';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import AddIcon from '@mui/icons-material/Add';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';

function Header({ toggleSidebar }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleBusClick = () => {
    navigate('/my-buses');
  };

  const handleOpenBusClick = () => {
    navigate('/open-bus');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getInitials = (firstName) => {
    if (!firstName) return '?';
    return firstName.charAt(0).toUpperCase();
  };

  const getFullName = () => {
    return `שלום ${user?.firstName || 'משתמש'}`;
  };


  return (
    <AppBar position="fixed">
      <Toolbar sx={{ paddingLeft: 2, paddingRight: 2 }}>
        {user && (
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              width: '100%'
            }}
          >

            {user.role === 'manager' && (
              <IconButton
                color="inherit"
                aria-label="פתח תפריט"
                edge="end"
                onClick={toggleSidebar}
              >
                <MenuIcon />
              </IconButton>
            )}

            {/* שם המשתמש - טקסט בדסקטופ, אווטר במובייל */}
            {isMobile ? (
              <Tooltip 
                title={getFullName()}
                open={tooltipOpen}
                onClose={() => setTooltipOpen(false)}
                onOpen={() => setTooltipOpen(true)}
                arrow
                placement="bottom"
              >
                <Avatar
                  sx={{ 
                    width: 32, 
                    height: 32, 
                    fontSize: '0.875rem',
                    backgroundColor: '#4caf50',
                    color: 'white',
                    cursor: 'pointer',
                    marginRight: 1,
                    border: '2px solid rgba(255,255,255,0.3)',
                    '&:hover': {
                      backgroundColor: '#45a049',
                      border: '2px solid rgba(255,255,255,0.5)',
                    }
                  }}
                  onClick={() => setTooltipOpen(!tooltipOpen)}
                >
                  {getInitials(user?.firstName)}
                </Avatar>
              </Tooltip>
            ) : (
              <Typography variant="subtitle1" sx={{ marginRight: 2 }}>
                שלום {user.firstName}
              </Typography>
            )}

            {/* בורר פרויקטים */}
            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
              <ProjectSelector />
              <InstallButton />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

              <IconButton 
                color="inherit" 
                onClick={handleBusClick}
                aria-label="רשימת אוטובוסים"
              >
                <DirectionsBusIcon />
              </IconButton>
              <IconButton 
                color="inherit" 
                onClick={handleOpenBusClick}
                aria-label="פתח אוטובוס חדש"
              >
                <AddIcon />
              </IconButton>
              <IconButton
                color="inherit"
                onClick={handleLogout}
                aria-label="התנתקות"
                edge="start"
              >
                <LogoutIcon />
              </IconButton>
            </Box>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}

export default Header;